import type { ComponentChildren } from "preact";
import { ageConfirmed, confirmAge } from "./age.js";

/**
 * Obean is for people 16 and over (ADR 0025): one click before a first game, on the app's pages
 * only (the website's pages never ask). Children aren't mentioned beyond the age itself.
 */
export function AgeGate(props: { children: ComponentChildren }) {
  if (ageConfirmed.value) return <>{props.children}</>;
  return (
    <section class="landing age-gate">
      <div class="card" role="dialog" aria-labelledby="age-title" aria-modal="false">
        <h1 id="age-title">Obean is for 16 and over</h1>
        <p>Games and quizzes for friends and family. Before your first game, please confirm.</p>
        <button
          type="button"
          onClick={() => {
            confirmAge();
          }}
        >
          I'm 16 or older
        </button>
        <p class="age-note">
          Under 16? Obean isn't for you yet. <a href="/">Back to obean.com</a>
        </p>
      </div>
    </section>
  );
}
